module.exports = __webpack_public_path__ + "MinionPro-Regular.14c36658760200d130ed.svg";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/MinionPro-Regular/MinionPro-Regular.svg
// module id = ../../../../../src/assets/fonts/MinionPro-Regular/MinionPro-Regular.svg
// module chunks = styles